<template>
  <div style="min-height: calc(100vh - 64px)" class="grey lighten-4">
    <v-btn depressed @click="() => $router.push({ name: 'UserRoleList' })">
      <v-icon>mdi-arrow-left</v-icon> บทบาท</v-btn
    >
    <v-form ref="form" lazy-validation>
      <v-container>
        <v-row>
          <v-col cols="12">
            <label>
              {{
                userRole.is_default
                  ? 'รายละเอียดบทบาท'
                  : $route.name === 'UserRoleAdd'
                  ? 'เพิ่มบทบาท'
                  : 'แก้ไขบทบาท'
              }}
            </label>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0" cols="12" md="5">
            <label class="body-2">
              ชื่อบทบาท (Role)
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-text-field
              :disabled="userRole.is_default"
              class="fix-google-chrome mt-1"
              v-model="userRole.title"
              tabindex="1"
              :rules="[(v) => !!v || 'โปรดระบุชื่อบทบาท (Role)']"
              required
              clearable
              @change="checkEmpty($event, 'title')"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0" cols="12" md="8">
            <label class="body-2">
              คำอธิบาย
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-text-field
              :disabled="userRole.is_default"
              class="fix-google-chrome mt-1"
              v-model="userRole.description"
              tabindex="2"
              :rules="[
                (v) => !!v || 'โปรดระบุคำอธิบาย',
                (v) =>
                  !v ||
                  (v && v.length <= 100) ||
                  'คำอธิบายต้องน้อยกว่า 100 ตัวอักษร',
              ]"
              required
              clearable
              @change="checkEmpty($event, 'description')"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>

        <!-- USER_ROLE_LIST -->
        <v-row>
          <v-col cols="12" md="8">
            <v-expansion-panels multiple v-model="panel">
              <v-expansion-panel
                v-for="statement in userRole.policy.Statements"
                :key="statement.id"
              >
                <v-expansion-panel-header class="pl-2 py-1">
                  <template v-slot:default>
                    <div class="d-flex align-center">
                      <v-btn
                        :disabled="userRole.is_default"
                        icon
                        @click.stop="handleDeleteRole(statement.id)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <span class="ml-2">
                        {{ statement.TitleTH || 'เลือกสิทธิ์' }}
                      </span>
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="statement.TitleTH">
                  <p class="mb-1">การอนุญาต</p>
                  <div v-for="(action, i) in statement.Actions" :key="i">
                    <v-card outlined class="px-4 py-2 mb-3">
                      <div
                        v-for="(subAction, i) in action.Actions"
                        :key="i"
                        class="d-flex align-center py-1"
                      >
                        <input
                          type="checkbox"
                          :disabled="userRole.is_default"
                          :id="subAction.TitleTH"
                          v-model="subAction.checked"
                        />
                        <label :for="subAction.TitleTH" class="ml-2">
                          {{ subAction.TitleTH }}
                        </label>
                      </div>
                      <div>
                        <div
                          class="mt-4 mb-2"
                          v-if="
                            action.Conditions &&
                            (action.Conditions.MustHaveAll ||
                              action.Conditions.AtLeastOne)
                          "
                        >
                          <v-btn
                            :disabled="
                              !action.Actions.some((s) => s.checked) ||
                              !userRole.title ||
                              !userRole.description
                            "
                            outlined
                            @click="handleChangeCondition(statement, action)"
                          >
                            เปลี่ยนเงื่อนไข
                          </v-btn>
                          <v-btn
                            :disabled="
                              !action.Actions.some((s) => s.checked) ||
                              !userRole.title ||
                              !userRole.description
                            "
                            class="ml-4"
                            color="error"
                            text
                            @click="
                              handleDeleteCondition(
                                statement.TitleTH,
                                action.id
                              )
                            "
                            >ลบเงื่อนไข</v-btn
                          >
                        </div>
                        <div
                          class="mt-4 mb-2"
                          v-else-if="
                            action.hasProperties ||
                            (userRole.is_default && !userRole.is_default)
                          "
                        >
                          <v-btn
                            :disabled="
                              !action.Actions.some((s) => s.checked) ||
                              !userRole.title ||
                              !userRole.description ||
                              $route.name === 'UserRoleAdd'
                            "
                            outlined
                            @click="handleSetCondition(statement, action)"
                          >
                            กำหนดเงื่อนไข
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-else>
                  <v-btn
                    style="width: 200px"
                    outlined
                    @click="handleChooseRole(statement.id)"
                  >
                    เลือกสิทธิ์
                  </v-btn>
                  <v-dialog
                    v-model="dialogAddUserRole"
                    scrollable
                    max-width="520px"
                  >
                    <v-card>
                      <v-card-text class="pa-0" style="height: 560px">
                        <div
                          v-for="(group, i) in policySpecification.PolicyGroups"
                          :key="i"
                        >
                          <h3 class="px-4 py-2 grey lighten-3">
                            {{ group.TitleTH }}
                          </h3>
                          <ul class="py-2">
                            <li
                              v-for="(resource, i) in group.Resources"
                              :key="i"
                              style="
                                list-style: none;
                                margin: 8px 16px;
                                cursor: pointer;
                              "
                              class="btn-link"
                              @click="handleSelectedRole(resource)"
                            >
                              <div
                                v-if="policySpecification.PolicySpecs[resource]"
                              >
                                {{
                                  policySpecification.PolicySpecs[resource]
                                    .TitleTH
                                }}
                              </div>
                            </li>
                          </ul>
                          <div
                            style="
                              padding-bottom: 16px;
                              text-align: center;
                              color: grey;
                            "
                            v-if="group.Resources.length === 0"
                          >
                            สิทธิ์ถูกเพิ่มไปแล้ว
                          </div>
                          <v-divider></v-divider>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <!-- USER_ROLE_LIST -->

        <v-row>
          <v-col cols="12" md="5">
            <v-btn
              :disabled="
                userRole.is_default ||
                (uiCtrl && !uiCtrl.isEnable('btn:::role:update'))
              "
              outlined
              @click="handleAddRole"
            >
              <v-icon small left>mdi-plus</v-icon>เพิ่มสิทธิ์
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="5">
            <v-btn
              v-if="$route.name === 'UserRoleAdd'"
              color="primary"
              @click="onSubmit"
              :disabled="
                !isUserRoleDataChange ||
                (uiCtrl && !uiCtrl.isEnable('btn:::role:create'))
              "
            >
              ตกลง
            </v-btn>
            <v-btn
              v-else
              color="primary"
              @click="onSave"
              :disabled="
                !isUserRoleDataChange ||
                (uiCtrl && !uiCtrl.isEnable('btn:::role:update'))
              "
            >
              บันทึก
            </v-btn>
            <v-btn class="ml-2" @click="onReset">ยกเลิก</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />

    <v-dialog v-model="dialogSetConditions" width="800" persistent scrollable>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          กำหนดเงื่อนไข
        </v-card-title>

        <v-card-text class="px-0 py-2">
          <v-tabs
            v-model="tabSetConditions"
            style="border-bottom: 1px solid #eeeeee"
          >
            <v-tab
              >ตรวจสอบบางเงื่อนไข
              <v-avatar
                class="ml-2"
                :color="tabSetConditions === 0 ? 'primary' : 'grey'"
                size="24"
              >
                <span class="white--text subtitle-2">
                  {{ setConditionAtLeastOneList.length }}
                </span>
              </v-avatar>
            </v-tab>
            <v-tab
              >ตรวจสอบทุกเงื่อนไข
              <v-avatar
                class="ml-2"
                :color="tabSetConditions === 1 ? 'primary' : 'grey'"
                size="24"
              >
                <span class="white--text subtitle-2">
                  {{ setConditionMustHaveAllList.length }}
                </span>
              </v-avatar>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabSetConditions">
            <v-tab-item>
              <div class="px-3 py-3 d-flex">
                <v-chip
                  ><v-icon left color="warning">mdi-alert-circle</v-icon
                  >ต้องตรงตามเงื่อนไข
                  <span class="ml-1" style="text-decoration: underline"
                    >อย่างน้อย 1 เงื่อนไข</span
                  ></v-chip
                ><v-btn outlined class="ml-auto" @click="handleAddConditions"
                  >เพิ่ม</v-btn
                >
              </div>
              <v-divider></v-divider>
              <div style="height: 420px; overflow-y: auto" class="px-4 py-4">
                <v-card
                  outlined
                  class="px-1 py-1 mb-3"
                  v-for="condition in setConditionAtLeastOneList"
                  :key="condition.id"
                >
                  <div class="d-flex align-center justify-space-between">
                    <div class="ml-3">
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'employee_uuid'"
                      >
                        พนักงาน
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'organization_uuid'"
                      >
                        หน่วยงาน
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'position_uuid'"
                      >
                        ตำแหน่ง
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'hardware_uuid'"
                      >
                        Device
                      </p>
                    </div>
                    <div>
                      <v-btn
                        text
                        color="primary"
                        small
                        @click="handleEditSetCondition(condition)"
                        >แก้ไข</v-btn
                      >|<v-btn
                        text
                        color="error"
                        small
                        @click="handleDeleteSetCondition(condition.id)"
                        >ลบ</v-btn
                      >
                    </div>
                  </div>
                  <div class="px-3">
                    <v-chip small v-if="condition.comparison === 'in'">
                      อยู่ในรายการ
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'employee'"
                      class="mb-1"
                    >
                      พนักงานที่กำลังใช้งาน
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'organization'"
                      class="mb-1"
                    >
                      หน่วยงานของตนเอง
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'organization_under'"
                      class="mb-1"
                    >
                      หน่วยงานของตนเอง และใต้สังกัด
                    </v-chip>
                    <v-chip
                      small
                      v-if="
                        condition.comparison === 'organization_select_under'
                      "
                      class="mb-1"
                    >
                      หน่วยงานที่เลือก และใต้สังกัด
                    </v-chip>
                  </div>
                  <div
                    v-if="condition.comparison === 'organization_select_under'"
                  >
                    <ul style="list-style: none" class="my-1 pl-3">
                      <li
                        v-for="organization in condition.dataIn"
                        :key="organization.organization_uuid"
                      >
                        - {{ organization.organization_code }}:
                        {{ organization.title_th }}
                      </li>
                    </ul>
                  </div>
                  <div v-if="condition.comparison === 'in'">
                    <ul
                      v-if="condition.resource === 'employee_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="employee in condition.dataIn"
                        :key="employee.employee_uuid"
                      >
                        - {{ employee.firstname_th }}
                        {{ employee.lastname_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'hardware_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="hardware in condition.dataIn"
                        :key="hardware.hardware_uuid"
                      >
                        - {{ hardware.hardware_code }}: {{ hardware.title_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'position_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="position in condition.dataIn"
                        :key="position.position_uuid"
                      >
                        - {{ position.position_code }}: {{ position.title_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'organization_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="organization in condition.dataIn"
                        :key="organization.organization_uuid"
                      >
                        - {{ organization.organization_code }}:
                        {{ organization.title_th }}
                      </li>
                    </ul>
                  </div>
                </v-card>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="px-3 py-3 d-flex">
                <v-chip
                  ><v-icon left color="warning">mdi-alert-circle</v-icon
                  >ต้องตรงตามเงื่อนไข
                  <span class="ml-1" style="text-decoration: underline"
                    >ทุกเงื่อนไข</span
                  ></v-chip
                ><v-btn outlined class="ml-auto" @click="handleAddConditions"
                  >เพิ่ม</v-btn
                >
              </div>
              <v-divider></v-divider>
              <div style="height: 420px; overflow-y: auto" class="px-4 py-4">
                <v-card
                  outlined
                  class="px-1 py-1 mb-3"
                  v-for="condition in setConditionMustHaveAllList"
                  :key="condition.id"
                >
                  <div class="d-flex align-center justify-space-between">
                    <div class="ml-3">
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'employee_uuid'"
                      >
                        พนักงาน
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'organization_uuid'"
                      >
                        หน่วยงาน
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'position_uuid'"
                      >
                        ตำแหน่ง
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'hardware_uuid'"
                      >
                        Device
                      </p>
                    </div>
                    <div>
                      <v-btn
                        text
                        color="primary"
                        small
                        @click="handleEditSetCondition(condition)"
                        >แก้ไข</v-btn
                      >|<v-btn
                        text
                        color="error"
                        small
                        @click="handleDeleteSetCondition(condition.id)"
                        >ลบ</v-btn
                      >
                    </div>
                  </div>
                  <div class="px-3">
                    <v-chip small v-if="condition.comparison === 'in'">
                      อยู่ในรายการ
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'employee'"
                      class="mb-1"
                    >
                      พนักงานที่กำลังใช้งาน
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'organization'"
                      class="mb-1"
                    >
                      หน่วยงานของตนเอง
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'organization_under'"
                      class="mb-1"
                    >
                      หน่วยงานของตนเอง และใต้สังกัด
                    </v-chip>
                    <v-chip
                      small
                      v-if="
                        condition.comparison === 'organization_select_under'
                      "
                      class="mb-1"
                    >
                      หน่วยงานที่เลือก และใต้สังกัด
                    </v-chip>
                  </div>
                  <div
                    v-if="condition.comparison === 'organization_select_under'"
                  >
                    <ul style="list-style: none" class="my-1 pl-3">
                      <li
                        v-for="organization in condition.dataIn"
                        :key="organization.organization_uuid"
                      >
                        - {{ organization.organization_code }}:
                        {{ organization.title_th }}
                      </li>
                    </ul>
                  </div>
                  <div v-if="condition.comparison === 'in'">
                    <ul
                      v-if="condition.resource === 'employee_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="employee in condition.dataIn"
                        :key="employee.employee_uuid"
                      >
                        - {{ employee.firstname_th }}
                        {{ employee.lastname_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'hardware_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="hardware in condition.dataIn"
                        :key="hardware.hardware_uuid"
                      >
                        - {{ hardware.hardware_code }}: {{ hardware.title_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'position_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="position in condition.dataIn"
                        :key="position.position_uuid"
                      >
                        - {{ position.position_code }}: {{ position.title_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'organization_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="organization in condition.dataIn"
                        :key="organization.organization_uuid"
                      >
                        - {{ organization.organization_code }}:
                        {{ organization.title_th }}
                      </li>
                    </ul>
                  </div>
                </v-card>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="!isSetConditionChange"
            color="primary"
            @click="handleSaveSetCondition"
          >
            บันทึก
          </v-btn>
          <v-btn @click="handleCancelSetCondition">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddConditions" width="640" persistent scrollable>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          <span v-if="statusSetCondition === 'add'">เพิ่มเงื่อนไข</span>
          <span v-else>แก้ไขเงื่อนไข</span>
        </v-card-title>

        <v-card-text class="px-4 py-4" style="height: 480px">
          <div>
            <label>
              เงื่อนไขของ "{{ selectedConditionStatement.TitleTH }}"
            </label>
            <v-autocomplete
              v-model="selectedConditionResource"
              :items="conditionResources"
              outlined
              dense
              color="blue-grey lighten-2"
              item-text="name"
              item-value="property"
              placeholder="เลือกเงื่อนไข"
              :disabled="statusSetCondition === 'edit'"
              @change="handleChangeConditionResource"
            >
            </v-autocomplete>
          </div>

          <div v-if="selectedConditionResource">
            <div>
              <label>การเปรียบเทียบ</label>
              <div
                v-if="selectedConditionResource === 'employee_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="in"
                  value="in"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="in" class="ml-2">พนักงานที่เลือก</label>
              </div>
              <div
                v-if="selectedConditionResource === 'organization_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="in"
                  value="in"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="in" class="ml-2">หน่วยงานที่เลือก</label>
              </div>
              <div
                v-if="selectedConditionResource === 'organization_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="organization_select_under"
                  value="organization_select_under"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="organization_select_under" class="ml-2">
                  หน่วยงานที่เลือก และใต้สังกัด
                </label>
              </div>
              <div
                v-if="selectedConditionResource === 'organization_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="organization"
                  value="organization"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="organization" class="ml-2">
                  หน่วยงานของตนเอง
                </label>
              </div>
              <div
                v-if="selectedConditionResource === 'organization_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="organization_under"
                  value="organization_under"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="organization_under" class="ml-2">
                  หน่วยงานของตนเอง และใต้สังกัด
                </label>
              </div>
              <div
                v-if="selectedConditionResource === 'employee_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="employee"
                  value="employee"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="employee" class="ml-2">พนักงานที่กำลังใช้งาน</label>
              </div>
            </div>

            <div class="d-flex flex-column mt-4">
              <div class="d-flex align-baseline">
                <label>ข้อมูล</label>
                <div class="ml-4" v-if="selectedDataIn.length">
                  <v-btn
                    text
                    small
                    color="primary"
                    @click="handleSelectData('edit')"
                    >แก้ไข</v-btn
                  >|<v-btn
                    text
                    small
                    color="error"
                    @click="handleClearSelectData"
                    >ล้าง</v-btn
                  >
                </div>
              </div>
              <div v-if="selectedDataIn.length" class="mt-1">
                <div v-if="selectedConditionResource === 'employee_uuid'">
                  <div
                    v-for="employee in selectedDataIn"
                    :key="employee.employee_uuid"
                  >
                    - {{ employee.firstname_th }}
                    {{ employee.lastname_th }}
                  </div>
                </div>
                <div v-if="selectedConditionResource === 'hardware_uuid'">
                  <div
                    v-for="hardware in selectedDataIn"
                    :key="hardware.hardware_uuid"
                  >
                    - {{ hardware.hardware_code }}: {{ hardware.title_th }}
                  </div>
                </div>
                <div v-if="selectedConditionResource === 'organization_uuid'">
                  <div
                    v-for="organization in selectedDataIn"
                    :key="organization.organization_uuid"
                  >
                    - {{ organization.organization_code }}:
                    {{ organization.title_th }}
                  </div>
                </div>
                <div v-if="selectedConditionResource === 'position_uuid'">
                  <div
                    v-for="position in selectedDataIn"
                    :key="position.position_uuid"
                  >
                    - {{ position.position_code }}: {{ position.title_th }}
                  </div>
                </div>
              </div>
              <div v-else>
                <v-btn
                  outlined
                  style="width: 200px"
                  class="mt-1"
                  :disabled="
                    conditionComparison === 'employee' ||
                    conditionComparison === 'organization' ||
                    conditionComparison === 'organization_under'
                  "
                  @click="handleSelectData('choose')"
                  >เลือก</v-btn
                >
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            @click="handleAddCondition"
            :disabled="
              !selectedConditionResource ||
              (!selectedDataIn.length &&
                conditionComparison !== 'employee' &&
                conditionComparison !== 'organization' &&
                conditionComparison !== 'organization_under')
            "
          >
            ตกลง
          </v-btn>
          <v-btn @click="handleCancelAddCondition">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSelectedData" width="480" persistent scrollable>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          เลือกข้อมูล
        </v-card-title>

        <div class="px-3 py-2">
          <v-text-field
            v-model="searchSelectedData"
            dense
            outlined
            hide-details
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </div>

        <v-card-text class="px-4" style="height: 360px">
          <div>
            <div v-if="selectedConditionResource === 'employee_uuid'">
              <div
                v-for="employee in employees"
                :key="employee.employee_uuid"
                class="d-flex align-center py-1"
              >
                <input
                  type="checkbox"
                  :id="employee.employee_uuid"
                  :value="employee"
                  v-model="selectedData"
                />
                <label :for="employee.employee_uuid" class="ml-2">
                  {{ employee.firstname_th }} {{ employee.lastname_th }}
                </label>
              </div>
            </div>
            <div v-if="selectedConditionResource === 'organization_uuid'">
              <div
                v-for="organization in organizations"
                :key="organization.organization_uuid"
                class="d-flex align-center py-1"
              >
                <input
                  :type="
                    conditionComparison === 'organization_select_under'
                      ? 'radio'
                      : 'checkbox'
                  "
                  :id="organization.organization_uuid"
                  :value="organization"
                  v-model="selectedData"
                />
                <label :for="organization.organization_uuid" class="ml-2">
                  {{ organization.organization_code }}:
                  {{ organization.title_th }}
                </label>
              </div>
            </div>
            <div v-if="selectedConditionResource === 'position_uuid'">
              <div
                v-for="position in positions"
                :key="position.position_uuid"
                class="d-flex align-center py-1"
              >
                <input
                  type="checkbox"
                  :id="position.position_uuid"
                  :value="position"
                  v-model="selectedData"
                />
                <label :for="position.position_uuid" class="ml-2">
                  {{ position.position_code }}: {{ position.title_th }}
                </label>
              </div>
            </div>
            <div v-if="selectedConditionResource === 'hardware_uuid'">
              <div
                v-for="hardware in hardwares"
                :key="hardware.hardware_uuid"
                class="d-flex align-center py-1"
              >
                <input
                  type="checkbox"
                  :id="hardware.hardware_uuid"
                  :value="hardware"
                  v-model="selectedData"
                />
                <label :for="hardware.hardware_uuid" class="ml-2">
                  {{ hardware.hardware_code }}: {{ hardware.title_th }}
                </label>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" @click="handleSubmitSelectedData">
            ตกลง
          </v-btn>
          <v-btn @click="handleCancelSelectedData">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      searchSelectedData: '',
      selectedData: [],
      selectedDataInit: [],
      statusSetCondition: '',
      statusSetConditionEditId: '',
      setConditionMustHaveAllList: [],
      setConditionMustHaveAllListInit: [],
      setConditionAtLeastOneList: [],
      setConditionAtLeastOneListInit: [],
      selectedConditionStatement: {},
      selectedConditionActions: [],
      selectedConditionActionId: '',
      selectedConditionPropertiesString: [],
      selectedConditionResource: '',
      conditionComparison: 'in',
      selectedDataIn: [],
      selectedDataInInit: [],
      tabSetConditions: 0,
      dialogSelectedData: false,
      dialogSetConditions: false,
      dialogAddConditions: false,
      dialogAddUserRole: false,
      panel: [],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      statementId: '',
      userRole: {
        policy: {
          Statements: [],
        },
      },
      userRoleInit: {
        policy: {
          Statements: [],
        },
      },
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isSetConditionChange() {
      if (
        JSON.stringify(this.setConditionMustHaveAllList) !==
          JSON.stringify(this.setConditionMustHaveAllListInit) ||
        JSON.stringify(this.setConditionAtLeastOneList) !==
          JSON.stringify(this.setConditionAtLeastOneListInit)
      ) {
        return true
      }
      return false
    },
    positions() {
      return this.$store.state.position.positions.filter(
        (position) =>
          position.title_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase()) ||
          position.position_code
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase())
      )
    },
    hardwares() {
      return this.$store.state.hardware.hardwares.filter(
        (hardware) =>
          hardware.title_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase()) ||
          hardware.hardware_code
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase())
      )
    },
    organizations() {
      return this.$store.state.organization.organizations.filter(
        (organization) =>
          organization.title_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase()) ||
          organization.organization_code
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase())
      )
    },
    employees() {
      return this.$store.state.employee.employees.filter(
        (employee) =>
          employee.firstname_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase()) ||
          employee.lastname_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase())
      )
    },
    isUserRoleDataChange() {
      if (
        this.userRole.title !== this.userRoleInit.title ||
        this.userRole.description !== this.userRoleInit.description ||
        JSON.stringify(this.userRole.policy.Statements) !==
          JSON.stringify(this.userRoleInit.policy.Statements)
      ) {
        return true
      }
      return false
    },
    conditionResources() {
      let resources = []

      this.selectedConditionPropertiesString.forEach((property) => {
        const propertyKey = property.Property.split(':').pop()
        const propertyText = {
          employee_uuid: 'พนักงาน',
          organization_uuid: 'หน่วยงาน',
          position_uuid: 'ตำแหน่ง',
          hardware_uuid: 'Device',
        }

        if (Object.keys(propertyText).includes(propertyKey)) {
          resources.push({
            name: propertyText[propertyKey],
            property: propertyKey,
            disabled:
              this.tabSetConditions === 0
                ? this.setConditionAtLeastOneList.some(
                    (item) => item.resource === propertyKey
                  )
                : this.setConditionMustHaveAllList.some(
                    (item) => item.resource === propertyKey
                  ),
          })
        }
      })

      return resources
    },
    policySpecification() {
      return {
        PolicyGroups:
          this.$store.state.userRole.policySpecification.PolicyGroups.map(
            (group) => {
              return {
                ...group,
                Resources: group.Resources.filter((resource) => {
                  return !this.userRole.policy.Statements.some(
                    (statement) => statement.Resource === resource
                  )
                }),
              }
            }
          ),
        PolicySpecs: this.$store.state.userRole.policySpecification.PolicySpecs,
      }
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'บทบาท',
        disabled: false,
        to: { name: 'UserRoleList' },
      },
      {
        text: `${this.$route.name === 'UserRoleAdd' ? 'เพิ่ม' : 'แก้ไข'}บทบาท`,
        disabled: true,
      },
    ])

    try {
      this.$store.state.loading = true

      if (this.$route.name === 'UserRoleAdd') {
        await this.fetchPolicySpecification({
          params: {
            company_uuid: this.$store.state.authentication.company.company_uuid,
          },
        })
      } else {
        await Promise.all([
          this.fetchUserRole({
            company_uuid: this.$store.state.authentication.company.company_uuid,
            role_uuid: this.$route.params.role_uuid,
          }),
          this.fetchPolicySpecification({
            params: {
              company_uuid:
                this.$store.state.authentication.company.company_uuid,
            },
          }),
        ])

        this.userRoleFormatData()
      }
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.$store.state.loading = false
    }
  },
  methods: {
    ...mapActions({
      fetchUserRole: 'userRole/fetchUserRole',
      addUserRole: 'userRole/addUserRole',
      updateUserRole: 'userRole/updateUserRole',
      fetchPolicySpecification: 'userRole/fetchPolicySpecification',
      fetchEmployees: 'employee/fetchEmployees',
      fetchOrganizations: 'organization/fetchOrganizations',
      fetchPositions: 'position/fetchPositions',
      fetchHardwares: 'hardware/fetchHardwares',
    }),
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    async submitConfirmDialogDelete(id) {
      try {
        this.confirmDialogDeleteLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const Statements = []
        this.userRole.policy.Statements.forEach((statement) => {
          statement.Actions.forEach((action) => {
            Statements.push({
              Effect: 'Allow',
              Resource: statement.Resource,
              Actions: action.Actions.filter((action) => action.checked).map(
                (action) => action.Action
              ),
              Conditions: action.id === id ? {} : action.Conditions,
            })
          })
        })

        const userRole = {
          title: this.userRole.title,
          description: this.userRole.description,
          policy: {
            Version: this.userRole.policy.Version || 1,
            Statements,
          },
        }

        await this.updateUserRole({
          company_uuid,
          role_uuid: this.userRole.role_uuid,
          userRole,
        })

        await this.fetchUserRole({
          company_uuid,
          role_uuid: this.userRole.role_uuid,
        })
        this.userRoleFormatData()

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        // this.userRole = {
        //   policy: {
        //     Statements: []
        //   }
        // }
        // this.userRoleInit = {
        //   policy: {
        //     Statements: []
        //   }
        // }

        // this.$router.push({ name: 'UserRoleList' })
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false
      }
    },
    userRoleFormatData() {
      const userRole = {
        ...this.$store.state.userRole.userRole,
        policy: {
          Version: this.$store.state.userRole.userRole.policy.Version,
          PolicyID: this.$store.state.userRole.userRole.policy.PolicyID,
          Statements: _.uniqBy(
            this.$store.state.userRole.userRole.policy.Statements,
            'Resource'
          ).map((statement) => {
            return {
              ...statement,
              id: uuidv4(),
              TitleTH:
                this.$store.state.userRole.policySpecification.PolicySpecs[
                  statement.Resource
                ].TitleTH,
              Actions:
                this.$store.state.userRole.policySpecification.PolicySpecs[
                  statement.Resource
                ].ActionPropertiesRequired.map((action) => {
                  return {
                    ...action,
                    id: uuidv4(),
                    hasProperties: !_.isEmpty(action.Properties),
                    Conditions:
                      this.$store.state.userRole.userRole.policy.Statements.find(
                        (item) =>
                          item.Actions.some((item) =>
                            action.Actions.some((s) => s.Action === item)
                          )
                      )?.Conditions || {},
                    Actions: action.Actions.map((action) => {
                      return {
                        ...action,
                        checked:
                          this.$store.state.userRole.userRole.policy.Statements.map(
                            (item) => item.Actions
                          )
                            .reduce((acc, curr) => acc.concat(curr), [])
                            .includes(action.Action),
                      }
                    }),
                  }
                }),
            }
          }),
        },
      }

      this.userRole = JSON.parse(JSON.stringify(userRole))
      this.userRoleInit = JSON.parse(JSON.stringify(userRole))
    },
    async handleDeleteCondition(title, id) {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบเงื่อนไข',
        value: title,
        item: id,
      }
    },
    handleCancelSetCondition() {
      this.dialogSetConditions = false
      this.setConditionMustHaveAllList = []
      this.setConditionAtLeastOneList = []
    },
    handleSubmitSelectedData() {
      this.selectedDataIn =
        this.conditionComparison === 'organization_select_under'
          ? [{ ...this.selectedData }]
          : [...this.selectedData]

      this.searchSelectedData = ''
      this.dialogSelectedData = false
    },
    handleCancelSelectedData() {
      this.selectedData = [...this.selectedDataInit]
      this.searchSelectedData = ''
      this.dialogSelectedData = false
    },
    async handleSaveSetCondition() {
      try {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const Conditions = {
          AtLeastOne: this.setConditionAtLeastOneList.reduce(
            (a, v) => ({
              ...a,
              [`prop:::${v.resource.split('_')[0]}:${v.resource}`]:
                v.comparison === 'in'
                  ? { StringIn: v.dataIn.map((data) => data[v.resource]) }
                  : v.comparison === 'employee'
                  ? { UserPropEqual: 'user:::employee:employee_uuid' }
                  : v.comparison === 'organization'
                  ? {
                      UserPropEqual:
                        'user:::employee:organization:organization_uuid',
                    }
                  : v.comparison === 'organization_under'
                  ? {
                      ValidationFunc: {
                        Function: 'func:::IsOrgPropInUserOrgPropTree',
                        UserArg:
                          'user:::employee:organization:organization_uuid',
                      },
                    }
                  : v.comparison === 'organization_select_under'
                  ? {
                      ValidationFunc: {
                        Function: 'func:::IsOrgPropInUserOrgPropTree',
                        StringArg: v.dataIn.map((data) => data[v.resource])[0],
                      },
                    }
                  : {},
            }),
            {}
          ),
          MustHaveAll: this.setConditionMustHaveAllList.reduce(
            (a, v) => ({
              ...a,
              [`prop:::${v.resource.split('_')[0]}:${v.resource}`]:
                v.comparison === 'in'
                  ? { StringIn: v.dataIn.map((data) => data[v.resource]) }
                  : v.comparison === 'employee'
                  ? { UserPropEqual: 'user:::employee:employee_uuid' }
                  : v.comparison === 'organization'
                  ? {
                      UserPropEqual:
                        'user:::employee:organization:organization_uuid',
                    }
                  : v.comparison === 'organization_under'
                  ? {
                      ValidationFunc: {
                        Function: 'func:::IsOrgPropInUserOrgPropTree',
                        UserArg:
                          'user:::employee:organization:organization_uuid',
                      },
                    }
                  : v.comparison === 'organization_select_under'
                  ? {
                      ValidationFunc: {
                        Function: 'func:::IsOrgPropInUserOrgPropTree',
                        StringArg: v.dataIn.map((data) => data[v.resource])[0],
                      },
                    }
                  : {},
            }),
            {}
          ),
        }

        const Statements = []
        this.userRole.policy.Statements.forEach((statement) => {
          statement.Actions.forEach((action) => {
            Statements.push({
              Effect: 'Allow',
              Resource: statement.Resource,
              Actions: action.Actions.filter((action) => action.checked).map(
                (action) => action.Action
              ),
              Conditions:
                action.id === this.selectedConditionActionId
                  ? action.Actions.some((s) =>
                      this.selectedConditionActions.includes(s.Action)
                    )
                    ? Conditions
                    : {}
                  : action.Conditions,
            })
          })
        })

        const userRole = {
          title: this.userRole.title,
          description: this.userRole.description,
          policy: {
            Version: this.userRole.policy.Version || 1,
            Statements,
          },
        }

        if (this.$route.name === 'UserRoleAdd') {
          await this.addUserRole({
            company_uuid,
            userRole,
          })
        } else {
          await this.updateUserRole({
            company_uuid,
            role_uuid: this.userRole.role_uuid,
            userRole,
          })
        }

        await this.fetchUserRole({
          company_uuid,
          role_uuid: this.userRole.role_uuid,
        })
        this.userRoleFormatData()

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'บันทึกข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        // this.userRole = {
        //   policy: {
        //     Statements: []
        //   }
        // }
        // this.userRoleInit = {
        //   policy: {
        //     Statements: []
        //   }
        // }

        // this.$router.push({ name: 'UserRoleList' })
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
        this.dialogSetConditions = false

        this.setConditionMustHaveAllList = []
        this.setConditionAtLeastOneList = []
      }
    },
    handleAddConditions() {
      this.dialogAddConditions = true
      this.statusSetCondition = 'add'
    },
    handleEditSetCondition(condition) {
      this.selectedConditionResource = condition.resource
      this.conditionComparison = condition.comparison
      this.selectedDataIn = [...condition.dataIn]
      this.selectedDataInInit = [...condition.dataIn]

      this.dialogAddConditions = true
      this.statusSetCondition = 'edit'
      this.statusSetConditionEditId = condition.id
    },
    handleDeleteSetCondition(id) {
      if (this.tabSetConditions === 0) {
        this.setConditionAtLeastOneList =
          this.setConditionAtLeastOneList.filter(
            (condition) => condition.id !== id
          )
      }
      if (this.tabSetConditions === 1) {
        this.setConditionMustHaveAllList =
          this.setConditionMustHaveAllList.filter(
            (condition) => condition.id !== id
          )
      }
      if (this.statusSetConditionEditId === id) {
        this.statusSetCondition = ''
        this.statusSetConditionEditId = ''
      }
    },
    handleCancelAddCondition() {
      this.selectedConditionResource = ''
      this.conditionComparison = 'in'
      this.selectedDataIn = []
      this.selectedDataInInit = []

      this.selectedData = []

      this.dialogAddConditions = false
    },
    handleAddCondition() {
      if (this.statusSetCondition === 'edit') {
        if (this.tabSetConditions === 0) {
          this.setConditionAtLeastOneList = this.setConditionAtLeastOneList.map(
            (condition) => {
              if (condition.id === this.statusSetConditionEditId) {
                return {
                  id: this.statusSetConditionEditId,
                  resource: this.selectedConditionResource,
                  comparison: this.conditionComparison,
                  dataIn: this.selectedDataIn,
                }
              }

              return condition
            }
          )
        }

        if (this.tabSetConditions === 1) {
          this.setConditionMustHaveAllList =
            this.setConditionMustHaveAllList.map((condition) => {
              if (condition.id === this.statusSetConditionEditId) {
                return {
                  id: this.statusSetConditionEditId,
                  resource: this.selectedConditionResource,
                  comparison: this.conditionComparison,
                  dataIn: this.selectedDataIn,
                }
              }

              return condition
            })
        }

        this.selectedConditionResource = ''
        // this.conditionComparison = 'in'
        this.selectedDataIn = []
        this.selectedDataInInit = []

        this.selectedData = []

        this.dialogAddConditions = false
        return
      }

      const condition = {
        id: uuidv4(),
        resource: this.selectedConditionResource,
        comparison: this.conditionComparison,
        dataIn: this.selectedDataIn,
      }

      if (this.tabSetConditions === 0) {
        const index = this.setConditionAtLeastOneList.findIndex(
          (item) => item.resource === condition.resource
        )

        if (index !== -1) {
          this.setConditionAtLeastOneList.splice(index, 1, condition)
        } else {
          this.setConditionAtLeastOneList.push(condition)
        }
      }

      if (this.tabSetConditions === 1) {
        const index = this.setConditionMustHaveAllList.findIndex(
          (item) => item.resource === condition.resource
        )

        if (index !== -1) {
          this.setConditionMustHaveAllList.splice(index, 1, condition)
        } else {
          this.setConditionMustHaveAllList.push(condition)
        }
      }

      this.selectedConditionResource = ''
      // this.conditionComparison = 'in'
      this.selectedDataIn = []
      this.selectedDataInInit = []

      this.selectedData = []

      this.dialogAddConditions = false
    },
    handleChangeConditionResource() {
      this.selectedDataIn = []
      this.selectedDataInInit = []

      this.selectedData = []
    },
    handleClearSelectData() {
      this.selectedDataIn = []
      this.selectedDataInInit = []

      this.selectedData = []
    },
    async handleSelectData(state) {
      if (state === 'edit') {
        this.selectedData = [...this.selectedDataIn]
        // this.selectedDataInit = [...this.selectedDataIn]
        this.dialogSelectedData = true
        return
      }
      try {
        if (this.selectedConditionResource === 'employee_uuid') {
          this.$store.state.loading = true

          const payload = {
            company_uuid: this.$store.state.authentication.company.company_uuid,
            params: {
              dpc: 'role-to-list-employee',
              is_active: true,
              sort: 'employee_code:asc',
              preset: 'selector',
            },
          }
          await this.fetchEmployees(payload)
        }

        if (this.selectedConditionResource === 'organization_uuid') {
          this.$store.state.loading = true

          const payload = {
            company_uuid: this.$store.state.authentication.company.company_uuid,
            params: {
              dpc: 'role-to-list-organization',
              sort: 'organization_code:asc',
              field: 'organization_uuid,organization_code,title_th',
            },
          }
          await this.fetchOrganizations(payload)
        }

        if (this.selectedConditionResource === 'position_uuid') {
          this.$store.state.loading = true

          const payload = {
            company_uuid: this.$store.state.authentication.company.company_uuid,
            params: {
              dpc: 'role-to-list-position',
            },
          }
          await this.fetchPositions(payload)
        }

        if (this.selectedConditionResource === 'hardware_uuid') {
          this.$store.state.loading = true

          const payload = {
            params: {
              dpc: 'role-to-list-hardware',
              company_uuid:
                this.$store.state.authentication.company.company_uuid,
            },
          }
          await this.fetchHardwares(payload)
        }

        this.dialogSelectedData = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    async handleChangeCondition(statement, action) {
      this.selectedConditionStatement = statement

      this.selectedConditionActions = action.Actions.map((item) => item.Action)

      this.selectedConditionActionId = action.id

      const actionsStatement =
        this.$store.state.userRole.userRole.policy.Statements.find(
          (statement) =>
            statement.Actions.some((action) =>
              this.selectedConditionActions.includes(action)
            )
        )

      if (!actionsStatement) {
        this.dialogSetConditions = true
        return
      }

      const conditions = actionsStatement.Conditions
      if (conditions.MustHaveAll || conditions.AtLeastOne) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          this.$store.state.loading = true

          await Promise.all([
            this.fetchEmployees({
              company_uuid,
              params: {
                dpc: 'role-to-list-employee',
                is_active: true,
                sort: 'employee_code:asc',
                preset: 'selector',
              },
            }),
            this.fetchHardwares({
              params: {
                dpc: 'role-to-list-hardware',
                sort: 'hardware_code:asc',
                company_uuid,
              },
            }),
            this.fetchOrganizations({
              company_uuid,
              params: {
                dpc: 'role-to-list-organization',
                sort: 'organization_code:asc',
                field: 'organization_uuid,organization_code,title_th',
              },
            }),
            this.fetchPositions({
              company_uuid,
              params: { dpc: 'role-to-list-position' },
            }),
          ])

          if (conditions.MustHaveAll) {
            const mustHaveAllData = Object.keys(conditions.MustHaveAll).map(
              (key) => {
                return {
                  id: uuidv4(),
                  resource: key.split(':').pop(),
                  comparison: !_.isEmpty(conditions.MustHaveAll[key].StringIn)
                    ? 'in'
                    : key.split(':').pop() === 'employee_uuid'
                    ? 'employee'
                    : key.split(':').pop() === 'organization_uuid' &&
                      !_.isEmpty(conditions.MustHaveAll[key].ValidationFunc) &&
                      !_.isEmpty(
                        conditions.MustHaveAll[key].ValidationFunc.UserArg
                      )
                    ? 'organization_under'
                    : key.split(':').pop() === 'organization_uuid' &&
                      !_.isEmpty(conditions.MustHaveAll[key].ValidationFunc) &&
                      !_.isEmpty(
                        conditions.MustHaveAll[key].ValidationFunc.StringArg
                      )
                    ? 'organization_select_under'
                    : 'organization',
                  dataIn:
                    key.split(':').pop() === 'organization_uuid' &&
                    !_.isEmpty(conditions.MustHaveAll[key].ValidationFunc) &&
                    !_.isEmpty(
                      conditions.MustHaveAll[key].ValidationFunc.StringArg
                    )
                      ? this.$store.state.organization.organizations.filter(
                          (h) =>
                            h.organization_uuid ===
                            conditions.MustHaveAll[key].ValidationFunc.StringArg
                        )
                      : _.isEmpty(conditions.MustHaveAll[key].StringIn)
                      ? ''
                      : key.split(':').pop() === 'hardware_uuid'
                      ? this.$store.state.hardware.hardwares.filter((h) => {
                          return conditions.MustHaveAll[key].StringIn.some(
                            (e) => e === h.hardware_uuid
                          )
                        })
                      : key.split(':').pop() === 'organization_uuid'
                      ? this.$store.state.organization.organizations.filter(
                          (h) => {
                            return conditions.MustHaveAll[key].StringIn.some(
                              (e) => e === h.organization_uuid
                            )
                          }
                        )
                      : key.split(':').pop() === 'position_uuid'
                      ? this.$store.state.position.positions.filter((h) => {
                          return conditions.MustHaveAll[key].StringIn.some(
                            (e) => e === h.position_uuid
                          )
                        })
                      : this.$store.state.employee.employees.filter((h) => {
                          return conditions.MustHaveAll[key].StringIn.some(
                            (e) => e === h.employee_uuid
                          )
                        }),
                }
              }
            )
            this.setConditionMustHaveAllList = [...mustHaveAllData]
            this.setConditionMustHaveAllListInit = [...mustHaveAllData]
          }

          if (conditions.AtLeastOne) {
            const atLeastOneData = Object.keys(conditions.AtLeastOne).map(
              (key) => {
                return {
                  id: uuidv4(),
                  resource: key.split(':').pop(),
                  comparison: !_.isEmpty(conditions.AtLeastOne[key].StringIn)
                    ? 'in'
                    : key.split(':').pop() === 'employee_uuid'
                    ? 'employee'
                    : key.split(':').pop() === 'organization_uuid' &&
                      !_.isEmpty(conditions.AtLeastOne[key].ValidationFunc) &&
                      !_.isEmpty(
                        conditions.AtLeastOne[key].ValidationFunc.UserArg
                      )
                    ? 'organization_under'
                    : key.split(':').pop() === 'organization_uuid' &&
                      !_.isEmpty(conditions.AtLeastOne[key].ValidationFunc) &&
                      !_.isEmpty(
                        conditions.AtLeastOne[key].ValidationFunc.StringArg
                      )
                    ? 'organization_select_under'
                    : 'organization',
                  dataIn:
                    key.split(':').pop() === 'organization_uuid' &&
                    !_.isEmpty(conditions.AtLeastOne[key].ValidationFunc) &&
                    !_.isEmpty(
                      conditions.AtLeastOne[key].ValidationFunc.StringArg
                    )
                      ? this.$store.state.organization.organizations.filter(
                          (h) =>
                            h.organization_uuid ===
                            conditions.AtLeastOne[key].ValidationFunc.StringArg
                        )
                      : _.isEmpty(conditions.AtLeastOne[key].StringIn)
                      ? ''
                      : key.split(':').pop() === 'hardware_uuid'
                      ? this.$store.state.hardware.hardwares.filter((h) => {
                          return conditions.AtLeastOne[key].StringIn.some(
                            (e) => e === h.hardware_uuid
                          )
                        })
                      : key.split(':').pop() === 'organization_uuid'
                      ? this.$store.state.organization.organizations.filter(
                          (h) => {
                            return conditions.AtLeastOne[key].StringIn.some(
                              (e) => e === h.organization_uuid
                            )
                          }
                        )
                      : key.split(':').pop() === 'position_uuid'
                      ? this.$store.state.position.positions.filter((h) => {
                          return conditions.AtLeastOne[key].StringIn.some(
                            (e) => e === h.position_uuid
                          )
                        })
                      : this.$store.state.employee.employees.filter((h) => {
                          return conditions.AtLeastOne[key].StringIn.some(
                            (e) => e === h.employee_uuid
                          )
                        }),
                }
              }
            )
            this.setConditionAtLeastOneList = [...atLeastOneData]
            this.setConditionAtLeastOneListInit = [...atLeastOneData]
          }

          this.dialogSetConditions = true
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      } else {
        this.dialogSetConditions = true
      }
    },
    async handleSetCondition(statement, action) {
      this.selectedConditionStatement = statement

      this.selectedConditionActions = action.Actions.map((item) => item.Action)
      this.selectedConditionActionId = action.id

      this.selectedConditionPropertiesString = [...action.Properties.String]

      this.dialogSetConditions = true
    },
    handleChooseRole(statementId) {
      this.dialogAddUserRole = true
      this.statementId = statementId
    },
    handleSelectedRole(resource) {
      this.userRole.policy.Statements = this.userRole.policy.Statements.map(
        (statement) => {
          if (statement.id === this.statementId) {
            return {
              ...statement,
              Resource: resource,
              TitleTH: this.policySpecification.PolicySpecs[resource].TitleTH,
              Actions: this.policySpecification.PolicySpecs[
                resource
              ].ActionPropertiesRequired.map((action) => {
                return {
                  ...action,
                  hasProperties: !_.isEmpty(action.Properties),
                  Actions: action.Actions.map((action) => {
                    return {
                      ...action,
                      checked: true,
                    }
                  }),
                }
              }),
            }
          }

          return statement
        }
      )
      this.dialogAddUserRole = false
    },
    handleAddRole() {
      this.userRole.policy.Statements.push({
        id: uuidv4(),
      })
    },
    handleDeleteRole(statementId) {
      this.userRole.policy.Statements = this.userRole.policy.Statements.filter(
        (statement) => statement.id !== statementId
      )
    },
    checkEmpty(value, field) {
      if (value) {
        this.userRole[field] = value.trim()
      }
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const Statements = []
        this.userRole.policy.Statements?.forEach((statement) => {
          statement.Actions?.forEach((action) => {
            Statements.push({
              Effect: 'Allow',
              Resource: statement.Resource,
              Actions: action.Actions.filter((action) => action.checked).map(
                (action) => action.Action
              ),
              Conditions: {},
            })
          })
        })

        const addUserRole = {
          title: this.userRole.title,
          description: this.userRole.description,
          policy: {
            Version: 1,
            Statements,
          },
        }

        const payload = {
          company_uuid,
          userRole: addUserRole,
        }

        this.addUserRole(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            this.userRole = {
              policy: {
                Statements: [],
              },
            }
            this.userRoleInit = {
              policy: {
                Statements: [],
              },
            }

            this.$router.push({ name: 'UserRoleList' })
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const Statements = []
        this.userRole.policy.Statements?.forEach((statement) => {
          statement.Actions?.forEach((action) => {
            Statements.push({
              Effect: 'Allow',
              Resource: statement.Resource,
              Actions: action.Actions.filter((action) => action.checked).map(
                (action) => action.Action
              ),
              Conditions: _.isEmpty(action.Conditions) ? {} : action.Conditions,
            })
          })
        })

        const userRole = {
          title: this.userRole.title,
          description: this.userRole.description,
          policy: {
            Version: this.userRole.policy.Version,
            Statements,
          },
        }

        const payload = {
          company_uuid,
          role_uuid: this.userRole.role_uuid,
          userRole,
        }

        this.updateUserRole(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            this.userRole = {
              policy: {
                Statements: [],
              },
            }
            this.userRoleInit = {
              policy: {
                Statements: [],
              },
            }

            this.$router.push({ name: 'UserRoleList' })
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item && item.type === 'next') {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.$router.push({ name: 'UserRoleList' })
      }
    },
    onReset() {
      this.$router.push({ name: 'UserRoleList' })
    },
    nextRoute(next) {
      next()
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isUserRoleDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
}
</script>
